import { Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-ticket-recall-dialog",
  templateUrl: "./ticket-recall-dialog.component.html",
  styleUrls: ["./ticket-recall-dialog.component.css"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatToolbar,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class TicketRecallDialogComponent {
  dialogRef = inject<MatDialogRef<TicketRecallDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
}
